<template>
  <div class="game-text-area-on-background-wrapper" :style="getStyle(startGameConfig)">
    <div
      v-for="(image, index) in imageData"
      :key="'image_' + index"
      class="image-container"
      :style="getImageStyle(image)"
    ></div>
    <tr-static-text
      :static-text="item"
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
    >
    </tr-static-text>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(boxConfig)"
      class="box-style"
    ></tr-box>
    <tr-text-area
      v-for="(item, index) in items"
      :key="item.id"
      :style="getCustomStyle(item)"
      :config="item"
      :tr-text-area-value="textAreaData[index]"
      :text-area-width="item.textAreaWidth || startGameConfig.textAreaWidth"
      :text-area-height="item.textAreaHeight || startGameConfig.textAreaHeight"
      :text-area-font-size="item.textAreaFontSize || startGameConfig.textAreaFontSize"
      :max-length="item.textAreaMaxLength || startGameConfig.textAreaMaxLength"
    ></tr-text-area>
  </div>
</template>

<script>
import _ from 'lodash';
import TrTextArea from '../TrInput/TrTextArea';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
import TrStaticText from '../TrInput/TrStaticText';
import * as utils from '../../Utils/inputUtils';
import * as mathematica from '../../Utils/mathematica';
import defaultMixin from '../../mixins/defaultMixin';
export default {
  name: 'tr-text-area-on-background',
  components: {
    TrTextArea,
    TrBox,
    TrStaticText,
  },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      words: [],
      boxConfig: {},
      textAreaData: [],
      staticText: [],
      imageData: {},
    };
  },
  beforeMount() {
    this.init();
  },
  mounted() {},
  created() {
    this.boxConfig = {
      x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
      y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
      width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
      height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
      unit: '%',
    };
  },
  methods: {
    init() {
      this.items = this.prepareData(this.startGameConfig.items);
      this.textAreaData = _.map(this.items, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
          caseSensitive: item.caseSensitive || this.caseSensitive,
          mathematica: item.mathematica,
        };
      });
      // console.log('  this.textAreaData', this.textAreaData);
      // this.longestWordLength = _.maxBy( this.textAreaData, ( item ) => {
      //   return item.correct.length;
      // } );
    },

    processData(node, staticText, imageArray, parentNode) {
      if (node.items) {
        // if(status.lengt>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    prepareData() {
      let staticText = [];
      let imageArray = [];
      let pick = this.startGameConfig.pick;
      let data = _.cloneDeep(this.startGameConfig.items);
      let staticIndexArray = _.filter(data, (item) => {
        return !_.isNil(item['staticIndex']);
      });
      if (staticIndexArray.length > 0) {
        pick = this.startGameConfig.pick - staticIndexArray.length;
        data = _.difference(data, staticIndexArray);
      }
      if (
        this.startGameConfig.items &&
        this.startGameConfig.pick &&
        _.isNumber(this.startGameConfig.pick) &&
        this.startGameConfig.pick > 0 &&
        this.startGameConfig.shuffle
      ) {
        data = _.sampleSize(_.cloneDeep(data), pick);
      } else if (
        this.startGameConfig.items &&
        this.startGameConfig.pick &&
        !_.isNumber(this.startGameConfig.pick) &&
        this.startGameConfig.shuffle
      ) {
        data = _.sampleSize(_.cloneDeep(data));
      } else if (this.startGameConfig.items && pick) {
        data = _.take(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && this.startGameConfig.shuffle) {
        data = _.shuffle(data);
      }
      _.each(staticIndexArray, (item) => {
        data.push(item);
      });
      data = _.flattenDeep(
        _.map(data, (item) => {
          return this.processData(item, staticText, imageArray, this.startGameConfig);
        })
      );
      /** add image layout */
      this.imageData = imageArray;
      if (this.startGameConfig.mainImage) {
        this.imageData.unshift(this.startGameConfig.mainImage);
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      /** shuffle words in box */
      if (this.startGameConfig.words) {
        this.words = _.shuffle(_.cloneDeep(this.startGameConfig.words));
      }
      /** set staticIndex (fixed position) */
      let sData = {};
      let staticData = _.filter(data, (item) => {
        return !_.isNil(item.staticIndex);
      });
      if (staticData.length > 0) {
        staticData = _.sortBy(_.cloneDeep(staticData), ['staticIndex']);
        data = _.map(data, (item) => {
          if (_.isNil(item.staticIndex)) {
            return item;
          }
        });
      }
      data = _.compact(data);
      sData = _.difference(data, staticData);
      _.each(staticData, (item) => {
        sData.splice(item.staticIndex, 0, item);
      });
      data = sData;
      /** add layout image */
      if (this.startGameConfig.layoutImage && this.startGameConfig.layoutImage.length) {
        let imageList = _.cloneDeep(this.imageData);
        let first;
        if (this.startGameConfig.mainImage) {
          first = _.head(imageList);
          imageList = _.tail(imageList);
        }
        this.imageData = _.map(_.cloneDeep(imageList), (item, index) => {
          return _.defaultsDeep(_.cloneDeep(item), _.cloneDeep(this.startGameConfig.layoutImage[index]));
        });
        if (this.startGameConfig.mainImage) {
          this.imageData.unshift(first);
        }
      }
      /** add static text */
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
        staticText = this.startGameConfig.staticText;
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.textItem = _.map(_.cloneDeep(data), (item, index) => {
        if (this.startGameConfig.layoutItems && this.startGameConfig.layoutItems[index]) {
          return _.defaultsDeep(item, _.cloneDeep(this.startGameConfig.layoutItems[index]));
        }
        return item;
      });
      /**
       * add words box to game
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.textItem, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.cloneDeep(this.textItem);
    },

    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {
      let status = _.reduce(
        this.textAreaData,
        (result, value, key) => {
          let temVal = null;
          let correctArray = _.isArray(value.correct) ? value.correct : [value.correct];
          let index = -1;
          if (value.mathematica && value.mathematica.expression) {
            let options = value.mathematica.expression;

            if (options.test && options.multipleLine) {
              index = _.findIndex(correctArray, (o) => {
                let test1 = mathematica.expressionTestMultipleLine(value.val);
                let expr1 = mathematica.expressionCalculate(value.val);
                let expr2 = mathematica.expressionCalculate(o);
                return test1 && parseFloat(expr1) === parseFloat(expr2);
              });
            } else if (options.test && options.multipleEqual) {
              index = _.findIndex(correctArray, (o) => {
                let test1 = mathematica.expressionTestMultipleEqual(value.val);
                let expr1 = mathematica.expressionCalculate(value.val);
                let expr2 = mathematica.expressionCalculate(o);
                return test1 && parseFloat(expr1) === parseFloat(expr2);
              });
            }
            // TODO: poprawić sprawdzanie dal działań innych niż równania
            // else if (options.test && options.multipleOperations) {
            //              index = _.findIndex(correctArray, (o) => {
            //                let test1 = mathematica.expressionTestMultipleEqual(value.val);
            //                let expr1 = mathematica.expressionCalculate(value.val);
            //                let expr2 = mathematica.expressionCalculate(o);
            //                return test1 && parseFloat(expr1) === parseFloat(expr2);
            //              });
            //            }
            else if (options.test) {
              index = _.findIndex(correctArray, (o) => {
                let expr = mathematica.expressionProcess(value.val);
                expr = expr[0];
                let expr2 = mathematica.expressionProcess(o);
                expr2 = expr2[0];
                return (
                  parseFloat(expr.lValue) === parseFloat(expr.rValue) &&
                  parseFloat(expr.lValue) === parseFloat(expr2.lValue) &&
                  parseFloat(expr.rValue) === parseFloat(expr2.rValue)
                );
              });
            } else if (options.calculate) {
              index = _.findIndex(correctArray, (o) => {
                let expr = mathematica.expressionCalculate(value.val);
                let expr2 = parseFloat(o);
                return parseFloat(o) === parseFloat(expr);
              });
            }
          } else {
            index = _.findIndex(value.correct, (o) => {
              if (value.caseSensitive) {
                return o === _.trim(value.val);
              } else {
                return o === _.trim(value.val.toLowerCase());
              }
            });
          }
          if (index != -1) {
            temVal = result && true;
            if (value.caseSensitive) {
              value.val = _.trim(value.val);
            } else {
              value.val = _.trim(value.val.toLowerCase());
            }
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.val = '';
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.textAreaData, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(
        {
          position: 'absolute',
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        },
        this.getCustomStyle(imageData),
        {
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
      );
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge(
        { position: 'absolute' },
        {
          left: utils.elementLeftPosition(box.x, 0, '%'),
          top: utils.elementTopPosition(box.y, 0, '%'),
          width: utils.elementWidth(box.width, '%'),
          height: utils.elementHeight(box.height, '%'),
        },
        this.getCustomStyle(box)
      );
    },
    getStyle(item) {
      let width = '1920px';
      let height = '1080px';
      if (item && item.cssStyle) {
        (width = item.cssStyle.width || width), (height = item.cssStyle.height || height);
      }
      return _.merge({}, { width: width, height: height }, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    caseSensitive() {
      return this.startGameConfig.caseSensitive;
    },
    maxCharNumber() {
      return _.round((this.longestWordLength.correct.length * 120) / 100).toString();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
.game-text-area-on-background-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: white;
  // background-image: url("~@/assets/icons/book/toolbox/przybornik_kosz.png");
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
